<template>
	<component
	:is="tag"
	v-bind="$attrs"
	role="button" class="
	group
	hover:outline 
	outline-gray-300
	active:outline-red-600 
	outline-2
	rounded-lg
	border
	border-2"
	:class="styleOverride?'':style+' '+styleBorder">
	
		
		<div class="
		h-fit
		flex flex-none flex-col
		justify-center
		items-start" >
			<div class="flex
			content-stretch
			items-stretch
			gap-1 w-full">
			<div class="inline-flex flex-col items-center self-stretch justify-between">
				<div class="flex w-full items-end">
					<img v-if="estructura" class='flex-none object-contain w-16 h-16' :class="styleOverride?'brightness-0':c.color.brightness" :src="require('@/assets/estructures/'+c.img)"/>
				
					<Pisos :castell="c.normalitzat[0]" class="pt-1 h-auto" :color="c.color.brightness=='brightness-0'?'border-black':'border-white'" mida="terç" />
				
				</div>
				<p v-if="estrelles" :class="c.gamma=='pc'?'opacity-0':''"><EstrellesFA class="text-[0.65rem] text-center h-4 flex items-center" :gamma="c.gamma"/></p>
			</div>
			
			<div class="flex flex-col text-black p-1 rounded-[0.4rem] px-2 grow"
			:class="c.resultat=='d'
			? 'bg-white'
			: styleResultat">

			<div class="inline-flex items-center gap-1 flex-nowrap text-nowrap">
				<font-awesome-icon v-if="universitaria" :icon="['fas','graduation-cap']" class="opacity-60" /><strong>{{ c.nom }}</strong><img v-if="novetat" class="h-4 w-4 drop-shadow" :src="Novetat"/>
				<span>&#8226;</span><p>{{ c.etiqueta }}</p>
				<div v-if="c.resultat!=='d'" class="p-1 aspect-square h-5 font-bold rounded flex items-center justify-center mr-1 bg-black text-white" >{{ c.resultat }}</div>
			</div>
			<div class="inline-flex items-center gap-1 flex-nowrap text-nowrap grow">
				<span  v-if="data"  class="opacity-60 ">{{ data }}</span>
				<span  v-if="diada"  class="opacity-60 ">{{ '&#8226; '+diada }}</span>
				<span  v-if="lloc"  class="opacity-60 ">{{ '&#8226; '+lloc }}</span>
				{{ ' ' }}
			</div>
			<div class="inline-flex items-center gap-1 flex-nowrap text-sm text-nowrap text-black/60 justify-self-end">
				<span>Gamma {{ c.nom_gamma }}</span>
				<span v-if="punts" class="inline-flex items-center gap-1 flex-nowrap text-nowrap ">
					&#8226;
					<p class="text-white bg-resultat-descarregat rounded flex items-center text-xs  font-bold px-1">d: {{c.punts.descarregat}}</p>
					&#8226;
					<p class="text-white bg-resultat-carregat rounded flex items-center text-xs  font-bold px-1">c: {{c.punts.carregat}}</p>
				</span>
				<span v-if="puntuat" class="inline-flex items-center gap-1 flex-nowrap text-nowrap ">
					&#8226;
					<p class="text-white bg-resultat-descarregat rounded flex items-center text-xs  font-bold px-1" :class="colorResultat">{{c.puntuat}}</p>
					
				</span>
			</div>
			</div>
		</div>
			<!--<p v-if="estrelles" class="text-sm text-center h-4 flex items-center">{{ c.estrelles }}</p>-->
			
			
		</div>
    </component>
</template>
<script setup>
import {defineProps} from 'vue';
import castell from '@/functions/notacioCastell.js';
import EstrellesFA from './EstrellesFA.vue';
import Novetat from '@/assets/novetat.svg'
import Pisos from './Pisos.vue';

const props=defineProps({
	tag:{
		type:String,
		default:'div'
	},
    castell:{
        type:String,
        default:"pd4"
    },
    universitaria:{
        type:Boolean,
        required:false,
        default:false
    },
	estrelles:{
        type:Boolean,
        required:false,
        default:true
	},
	punts:{
        type:Boolean,
        required:false,
        default:false
	},
	estructura:{
        type:Boolean,
        required:false,
        default:true
	},
	compacte:{
        type:Boolean,
        required:false,
        default:false
	},
	puntuat:{
        type:Boolean,
        required:false,
        default:false
	},
	novetat:{
        type:Boolean,
        required:false,
        default:false
	},
	styleOverride:{
        type:Boolean,
        required:false,
        default:false
	},
	data:{
        type:String,
        required:false,
    },
	diada:{
        type:String,
        required:false,
    },
	lloc:{
        type:String,
        required:false,
    }
});


const c = castell(props.castell,props.universitaria);
const style= ' bg-'+c.color.gamma+' text-'+c.color.text;
const styleBorder= ' border-'+c.color.gamma;
const styleResultat = 'border-2 border bg-'+c.color.resultat+'_l border-'+c.color.resultat
const colorResultat = ' bg-'+c.color.resultat
</script>